<template>
  <b-form>
    <b-card>
      <b-card-text>
        <b-row>
          <b-col
            sm="12"
            md="6"
          ><h6 class="mb-1">
            Ürün Güncelle
          </h6></b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group
              label="Marka"
            >
              <v-select
                v-model="id_brands"
                label="title"
                :options="brands"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group
              label="Ürün Grubu"
            >
              <v-select
                v-model="id_product_types"
                label="title"
                :options="productTypes"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="Ürün Kodu">
              <b-form-input
                v-model="formData.pcode"
                placeholder="Ürün Kodu"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="8"
          >
            <b-form-group label="Ürün Adı">
              <b-form-input
                v-model="formData.title"
                placeholder="Ürün Adı"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="Malzeme Birim Fiyatı">
              <cleave
                v-model="formData.list_price"
                class="form-control"
                :raw="true"
                :options="maskOptions.number"
                placeholder="Malzeme Birim Fiyatı"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="İşçilik Fiyatı">
              <cleave
                v-model="formData.labor_price"
                class="form-control"
                :raw="true"
                :options="maskOptions.number"
                placeholder="İşçilik Fiyatı"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group
              label="Para Birimi"
            >
              <v-select
                v-model="id_currencies"
                label="title"
                :options="currencies"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-button
      variant="danger"
      :disabled="submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </b-form>
</template>

<script>
import {
  BForm,
  BCard,
  BCardText,
  BFormInput,
  BFormTextarea,
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BInputGroupPrepend,
  BInputGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.tr'

export default {
  name: 'ProductsEdit',
  components: {
    BForm,
    BCard,
    BCardText,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    vSelect,
    BRow,
    BCol,
    BButton,
    Cleave,
    BInputGroupPrepend,
    BInputGroup,
  },
  data() {
    return {
      submitStatus: false,
      id_brands: {
        id: null,
        title: null,
      },
      id_product_types: {
        id: null,
        title: null,
      },
      id_currencies: {
        id: null,
        title: null,
      },
      formData: {
        pcode: null,
        title: null,
        list_price: null,
        labor_price: null,
        id_brands: null,
        id_product_types: null,
        id_currencies: null,
      },
      maskOptions: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
        },
      },
    }
  },
  computed: {
    productData() {
      return this.$store.getters['products/getProduct']
    },
    brands() {
      return this.$store.getters['brands/getBrands']
    },
    productTypes() {
      return this.$store.getters['productTypes/getProduct_types']
    },
    currencies() {
      return this.$store.getters['currencies/getCurrencies']
    },
    saveStatus() {
      const status = this.$store.getters['products/getProductSaveStatus']
      return status
    },
  },
  watch: {
    productData(val) {
      console.log(val)
      this.setFormData(val)
    },
    saveStatus(val) {
      if (val.status === true) {
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getBrands()
    this.getProductTypes()
    this.getCurrencies()
    this.getProduct()
  },
  methods: {
    getProduct() {
      this.$store.dispatch('products/productView', this.$route.params.id)
    },
    setFormData(data) {
      this.formData = data
      this.id_brands = {
        id: data.id_brands,
        title: data.brand,
      }
      this.id_product_types = {
        id: data.id_product_types,
        title: data.product_type,
      }
      this.id_currencies = {
        id: data.id_currencies,
        title: data.currency,
      }
    },
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    getBrands() {
      this.$store.dispatch('brands/brandsList', {
        select: ['brands.id AS id', 'brands.title AS title'],
      })
    },
    getProductTypes() {
      this.$store.dispatch('productTypes/product_typesList', {
        select: ['product_types.id AS id', 'product_types.title AS title'],
      })
    },
    getCurrencies() {
      this.$store.dispatch('currencies/currenciesList', {
        select: ['currencies.id AS id', 'currencies.title AS title'],
      })
    },
    submitForm() {
      this.submitStatus = true
      const submitData = this.formData
      submitData.id_brands = this.id_brands.id
      submitData.id_product_types = this.id_product_types.id
      submitData.id_currencies = this.id_currencies.id
      this.$store.dispatch('products/productSave', this.formData)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
